import { createSlice } from "@reduxjs/toolkit";
import { getShippingList } from "../../api/shipping";

const initialState = {
  isLoading: false,
  shippingDetails: [],
  carrierDetails: [],
  shippingCostList: [],
};

export const shippingSlice = createSlice({
  name: "shipping",
  initialState,
  reducers: {
    getShippingCostList: (state, { payload }) => {
      state.shippingCostList = payload;
    },
  },
  extraReducers: {
    [getShippingList.pending]: (state) => {
      state.isLoading = true;
    },
    [getShippingList.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.shippingDetails = payload;
      state.carrierDetails = payload;
    },
    [getShippingList.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});
export const { getShippingCostList } = shippingSlice.actions;
export const shippingSelector = (state) => state.shipping;
export default shippingSlice.reducer;
